
export default {
  name: 'TutorialImageTextVertical',

  props: {
    data: {
      type: Object,
      default: () => ({
        imagePath: {},
        label: '單身貴族',
        description: `一旦遇到傷病，受保人希望得到較
好的醫療服務，以醫保抵銷醫療開
支，並可發揮扣稅功用。`
      }),
    },
  },

  data() {
    return {
      imagePath: this.data?.imageObj?.url || '',
      imageAlt: this.data?.imageObj?.alternativeText || '',
      label: this.data?.title,
      description: this.data?.description,
    }
  },
}
